import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {UserRequestDetailComponent} from "../user-request-detail/user-request-detail.component";
import {DynamicModalFormComponent} from "../../../common/dynamic-modal-form/dynamic-modal-form.component";
import {BadgeComponent} from "../../../common/badge/badge.component";
import {
  UserRequestComparatorComponent
} from "../../../common/user-request-comparator/user-request-comparator.component";
import {UserRequest} from "../../../../model/UserRequest";
import {FaqCategory} from "../../../../model/FaqCategory";
import {PartialRequestFormGeneratorService} from "../../../../formulaires/admin/partial-request-form-generator.service";

@Component({
    selector: 'app-user-requests-partial-accept',
    imports: [
        CommonModule,
        DynamicModalFormComponent,
        FormsModule,
        BadgeComponent,
        FaIconComponent,
        UserRequestComparatorComponent,
        UserRequestDetailComponent,
    ],
    templateUrl: './user-requests-partial-accept.component.html',
    styleUrl: './user-requests-partial-accept.component.scss'
})
export class UserRequestsPartialAcceptComponent {
  @Input()
  request: UserRequest;
  @Input()
  crmUrl: string;
  @Input()
  categories: FaqCategory[] = [];

  @Output()
  submit = new EventEmitter();
  @Output()
  cancel = new EventEmitter();

  constructor(public partialRequestFormGeneratorService: PartialRequestFormGeneratorService) {
  }

  getCategoryFromSlug(p: any): FaqCategory {
    return this.categories.find(c => {
      return c.slug.toLowerCase() === p.toLowerCase();
    });
  }

  onSubmit($event): void {
    this.submit.emit($event);
  }

  onCancel() {
    this.cancel.emit();
  }
}
